// extracted by mini-css-extract-plugin
module.exports = {"accordionDefault":"_c6184ef","accordion":"_1680acf"};